angular.module('core')
    .filter('periodFormat', function ($filter) {
        let minutesOfDay = m => moment(m).minutes() + moment(m).hours() * 60;

        let dateFormatStart = (startTime, endTime) => {
            if (moment().isSame(startTime, 'day')) {
                if (minutesOfDay(startTime) === 0) {
                    return "'dziś'"
                } else {
                    return "'dziś' H:mm"
                }

            }
            if (minutesOfDay(startTime) === 0 && minutesOfDay(endTime) === 0) {
                return "d MMM y"
            }
            return "d MMM y H:mm"
        }

        let dateFormatEnd = (startTime, endTime) => {
            if (minutesOfDay(startTime) === 0 && minutesOfDay(endTime) === 0) {
                if (isSameDay(startTime, endTime))
                    return "'"
                return " - d MMM y"
            }
            if (isSameDay(startTime, endTime))
                return " - H:mm"
            return " - d MMM y H:mm"
        }

        let isSameDay = (startTime, endTime) => {
            if (startTime !== null && endTime !== null) {
                let start = moment(startTime);
                return start.isSame(endTime, 'day') || moment(endTime).subtract(1, "milliseconds").isSame(start, 'day');
            }
            return false
        }

        return function (startTime, endTime) {

            if (startTime === null || endTime === null) {
                return "";
            }
            let endTimeCalculated = (minutesOfDay(endTime) === 0) ? moment(endTime).subtract(1, "milliseconds").format() : endTime;


            return $filter('date')(startTime, dateFormatStart(startTime, endTime)) + $filter('date')(endTimeCalculated, dateFormatEnd(startTime, endTime));
        };
    })
    .filter('periodFormatOne', ['$filter', function ($filter) {
        var minutesOfDay = function (m) {
            return moment(m).minutes() + moment(m).hours() * 60;
        };

        var dateFormatStart = function (startTime, endTime) {
            if (moment().isSame(startTime, 'day')) {
                if (minutesOfDay(startTime) === 0) {
                    return "'dziś'";
                } else {
                    return "'dziś' H:mm";
                }

            }
            if (minutesOfDay(startTime) === 0 && minutesOfDay(endTime) === 0) {
                return 'd MMM y';
            }
            return 'd MMM y H:mm';
        };

        var dateFormatEnd = function (startTime, endTime) {
            if (minutesOfDay(startTime) === 0 && minutesOfDay(endTime) === 0) {
                if (isSameDay(startTime, endTime))
                    return "''";
                return ' - d MMM y';
            }
            if (isSameDay(startTime, endTime))
                return ' - H:mm';
            return ' - d MMM y H:mm';
        };

        var isSameDay = function (startTime, endTime) {
            if (startTime !== null && endTime !== null) {
                var start = moment(startTime);
                return start.isSame(endTime, 'day') || moment(endTime).subtract(1, "milliseconds").isSame(start, 'day');
            }
            return false;
        };

        return function (startTime, endTime) {

            if (startTime === null || endTime === null) {
                return "";
            }
            var endTimeCalculated = (minutesOfDay(endTime) === 0) ? moment(endTime).subtract(1, "milliseconds") : endTime;

            return $filter('date')(startTime, dateFormatStart(startTime, endTime));
        };
    }])
